module.exports = __webpack_public_path__ + "static/media/logo_demello_LARGE.b35dc8ab.png";